///////////////////////////////////////////////////////////////////////////////////////////////////
//     _                            __
//    (_)___ ___  ____  ____  _____/ /_
//   / / __ `__ \/ __ \/ __ \/ ___/ __/
//  / / / / / / / /_/ / /_/ / /  / /_
// /_/_/ /_/ /_/ .___/\____/_/   \__/
//            /_/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

import BackButton from '@/components/pages/BackButton'
import Errors from '@/components/pages/Errors'
import Filter from '@/components/pages/filter/Filter'
import LoadingScreen from '@/components/pages/LoadingScreen'
import LoadingSpinner from '@/components/pages/LoadingSpinner'
import Logo from '@/components/images/Logo'
import NoFiltersMessage from '@/components/pages/filter/NoFiltersMessage'
import Page from '@/components/pages/Page'
import PageHeading from '@/components/pages/PageHeading'
import SearchResults from '@/components/pages/searchResults/SearchResults'
import Snackbar from '@/components/pages/Snackbar'

///////////////////////////////////////////////////////////////////////////////////////////////////
//                     _      __
//    ________  ____ _(_)____/ /____  _____
//   / ___/ _ \/ __ `/ / ___/ __/ _ \/ ___/
//  / /  /  __/ /_/ / (__  ) /_/  __/ /
// /_/   \___/\__, /_/____/\__/\___/_/
//           /____/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

export default {
  'c-back-button': BackButton,
  'c-errors': Errors,
  'c-filter': Filter,
  'c-loading-screen': LoadingScreen,
  'c-loading-spinner': LoadingSpinner,
  'c-logo': Logo,
  'c-no-filters-message': NoFiltersMessage,
  'c-page': Page,
  'c-page-heading': PageHeading,
  'c-search-results': SearchResults,
  'c-snackbar': Snackbar,
}
